import axios from 'axios';
import cookies from 'js-cookie';
import { Modal, notification } from 'antd';
import CustomResponse from './CustomResponse';
import api from '@root/utils/api';
import { _CITY_, envConfig } from 'udian-tob-lib';
import ZhuyunLogin from '@root/service/zhuyunLogin';

let _token = cookies.get('token'),
  _userinfo = cookies.get('userinfo') && JSON.parse(cookies.get('userinfo')),
  _tokenId = cookies.get('tokenId');

// console.log(cookies.domain)

let _config = {
  buildTo: 'dev',
  isShowEnv: process.env.IS_UAT, //是否是演示环境
  token: _token, // token
  domain: 'net', // 域名后缀
  apiBaseURL: null, // api 服务器地址
  imgServerUrl: null, //img 的url
  userInfoApiUrl: api.common.getUserInfo, // 获取用户的api
  logoutApiUrl: api.common.loginout, // 登出的api
};

let userInfoPromise;
let menuInfoPromise;

class AuthManager {
  _userInfo = _userinfo || null;
  _token = _token || null;
  _inited = false;
  fetchUrl = '';
  menus = [];
  isReportSkip = false;
  /**
   * 初始化
   * @param {String} BUILD_TO 'dev' || 'test || 'com' || 'cn'
   * @param {String} tokenKey ajax请求header里token的key
   */
  init(BUILD_TO, tokenKey = 'token') {
    if (this._inited) {
      return this;
    }
    this._inited = true;
    _config.buildTo = BUILD_TO;
    // console.log(BUILD_TO)
    /* api基础地址 */
    _config.domain = BUILD_TO === 'prod' ? 'com' : 'net';
    this.fetchUrl = this.getApiUrl('dispatch');
    _config.apiBaseURL = this.fetchUrl;
    /* 静态资源 */
    // _config.imgServerUrl = IMG_SERVER_URL[BUILD_TO];
    axios.defaults.baseURL = _config.apiBaseURL;
    axios.defaults.timeout = 6000;
    this.isReportSkipPage();
    if (this.isReportSkip) return this;
    if (!!_config.token && !!_userinfo && !!_tokenId) {
      axios.defaults.headers[tokenKey] = _config.token;
    }
    return this;
  }
  registDefaultInterceptors() {
    // axios请求拦截器配置
    axios.interceptors.request.use(
      function (config) {
        // Do something before request is sent
        if (config.method === 'post') {
          let postData = config.data || {};
          config.data = postData;
        }
        return config;
      },
      function (error) {
        // Do something with request error
        return Promise.reject(error);
      }
    );
    // axios返回拦截器配置
    axios.interceptors.response.use(
      (response) => {
        response = new CustomResponse(response);
        const code = response.data.code;
        switch (code) {
          case 0:
            break;
          case 5:
          case 20001:
            // 未登陆跳转到登陆界面
            if (_token) {
              ZhuyunLogin.gotoLoginPage();
            }
            break;
          case 3502:
            Modal.warning({ title: '您没有权限进行该操作！', okText: '关闭', okType: 'default' });
            return Promise.reject();
          default:
            response._notification();
        }
        /* 非0时抛出错误，抛出错误时默认弹出msg，如果要取消默认，请执行error.cancelAlert() */
        if (code !== 0) {
          if (response.data.msg.length > 200) response.data.msg = '服务器出错';
          return Promise.reject(response);
        }
        return response;
      },
      (error) => {
        // Do something with response error
        error.data = error.data || {};
        notification.info('服务器内部错误');
        return Promise.reject(null);
      }
    );
    return this;
  }
  _setCookie(name, value, domain) {
    var Days = 30;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    var _domain = domain ? ';domain=' + domain : '';
    document.cookie =
      encodeURIComponent(name) +
      '=' +
      encodeURIComponent(value) +
      ';expires=' +
      exp.toGMTString() +
      _domain;
  }
  getPostCommonParms() {
    return {
      token: _config.token,
      roleIdList: ['test_roleId'],
      tenantId: 'string',
    };
  }
  serBaseUrl(value) {
    _config.baseURL = value;
    axios.defaults.baseURL = value;
    return this;
  }
  getMenu() {
    if (!menuInfoPromise) {
      menuInfoPromise = axios
        .post(_config.apiBaseURL + api.common.menuList, {})
        .then((res) => {
          // if( res.data.code !==0) return this.authInfoOutOfTime()
          const menus = res.data.data;
          let menuMap = new Map();
          menus.map((item) => {
            menuMap.set(item.code, item);
            return item;
          });
          return Promise.resolve(menuMap);
        })
        .catch((err) => {
          // this.authInfoOutOfTime()
        });
    }
    return menuInfoPromise;
  }
  getConfig() {
    return Object.assign({}, _config);
  }
  setConfig(config) {
    return Object.assign(_config, config);
  }
  getUserInfo(appId) {
    if (!userInfoPromise) {
      userInfoPromise = axios
        .post(
          _config.apiBaseURL + _config.userInfoApiUrl,
          { token: _config.token },
          {
            headers: {
              token: _config.token,
            },
          }
        )
        .then((res) => {
          // if (res.data.code !== 0)
          //     this.authInfoOutOfTime();
          if (res.data.code === 0) {
            this._userInfo = this.copy(res.data.data);
          }
          return res;
        });
    }
    return userInfoPromise;
  }
  // 判断是否是跳报表页面
  isReportSkipPage() {
    const curHref = window.location.href;
    if (curHref.indexOf('goto=http://bigdata.dotransit.com&token=') > -1) {
      this.isReportSkip = true;
    }
  }
  async getUserByTokenId(tokenId) {
    return axios
      .post(api.common.getUserByTokenId, {
        tokenId: tokenId,
      })
      .then((res) => {
        this.loginSuccess(res.data.data);
        return Promise.resolve(true);
      })
      .catch((err) => {
        err && err.cancelAlert();
        return Promise.resolve(false);
      });
  }
  setUser(userinfo) {
    this._userInfo = userinfo;
  }
  getUser() {
    return this.copy(this._userInfo);
  }
  getCookies(key) {
    return cookies.get(key);
  }
  loginSuccess(userinfo) {
    const _name = window.location.host.split('dotransit')[0].split('.')[1];
    // console.log(userinfo)
    axios.defaults.headers['token'] = userinfo.token;
    this._userInfo = userinfo;
    _config.token = userinfo.token;
    let _domain = (_name ? '.' + _name : '') + _CITY_.domain + _config.domain;
    cookies.set('token', userinfo.token, { domain: _domain });
    cookies.set('userinfo', userinfo, { domain: _domain });
    cookies.set('tokenId', userinfo.token, { domain: _domain });
    cookies.set('domain', _domain.slice(1), { domain: _domain });
    // 三级域名
    if (_domain.split('.').length > 3) {
      localStorage.setItem('token', userinfo.token);
    }
  }
  logout(goto) {
    return axios
      .post(
        _config.apiBaseURL + _config.logoutApiUrl,
        {},
        {
          headers: {
            token: _config.token,
          },
        }
      )
      .then((res) => {
        this.toLoginPage(goto);
      });
  }
  toLoginPage(goto) {
    if (window.location.pathname === '/agreement') return;
    if (window.location.pathname === '/privacy') return;
    const _name = window.location.host.split('dotransit')[0].split('.')[1];
    let _domain = _name + _CITY_.domain + _config.domain;
    cookies.remove('token', { domain: _domain });
    cookies.remove('userinfo', { domain: _domain });
    cookies.remove('tokenId', { domain: _domain });
    cookies.remove('domain', { domain: _domain });
    // 针对三级域名，同时清除其二级域名cookie
    if (_name) {
      const p_domain = '.' + _domain.match(/(.[^.]*)\.(.*)/)[2];
      cookies.remove('token', { domain: p_domain });
      cookies.remove('userinfo', { domain: p_domain });
      cookies.remove('tokenId', { domain: p_domain });
      cookies.remove('domain', { domain: p_domain });
      localStorage.removeItem('token');
    }
    const curHref = window.location.href;
    if (curHref === window.location.origin + '/') return;
    if (curHref.indexOf('goto=') > -1 && curHref.split('goto=')[1]) {
      const url = curHref.split('goto=')[1];
      const hash = url.indexOf('#') > -1 ? '' : '#';
      window.location.href = window.location.origin + '/?goto=' + url + hash;
    } else {
      window.location.href = window.location.origin;
    }
  }
  authInfoOutOfTime() {
    if (window.location.pathname === '/agreement') return;
    if (window.location.pathname === '/privacy') return;
    this.toLoginPage();
  }
  copy(source) {
    return JSON.parse(JSON.stringify(source));
  }
  getApiUrl(domain, env = _config.buildTo) {
    if (
      window.location.protocol === 'https:' &&
      env === 'prod' &&
      process.env.CITY === 'shenzhen'
    ) {
      return 'https://apidispatch.dotransit.com';
    }

    const url = envConfig.getApiUrl(domain, env);
    return url;
  }
  /**
   * @name 获取web地址
   * @param {string} domain 域名
   * @param {string} env 环境
   */
  getPassortUrl(env = _config.buildTo) {
    return envConfig.getPassortUrl(env);
  }
}

const auth = new AuthManager();

/* 方便调试使用 */
window.authManager = auth;

export default auth;



// WEBPACK FOOTER //
// ./src/service/auth-manager.js